const queries = [
  {
    icon: 'ri-map-pin-line',
    query: 'Orthodontist near Chatsworth for braces and teeth straightening',
    answer: 'Smile By Dr. K · 10234 Canoga Ave, Chatsworth, CA 91311 · (818) 341-5150',
  },
  {
    icon: 'ri-video-chat-line',
    query: 'Virtual orthodontic consultation in Chatsworth CA',
    answer: 'Virtual consultations available — start your smile assessment online, no office visit required.',
  },
  {
    icon: 'ri-group-2-line',
    query: 'Best orthodontist near me for kids, teens, and adults',
    answer: 'Dr. K provides expert orthodontic care for all ages at our Chatsworth practice, conveniently located on Canoga Ave.',
  },
];

export default function VoiceSearchSection() {
  return (
    <section className="bg-[#1C3528] py-20 md:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-8 h-px bg-[#C4A96E]" />
              <span
                className="text-[#C4A96E] text-[10px] tracking-[0.32em] uppercase font-semibold"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                Voice &amp; AI Search
              </span>
            </div>
            <h2
              className="text-[36px] md:text-[48px] text-white font-semibold leading-[1.08]"
              style={{ fontFamily: 'Cormorant Garamond, serif', letterSpacing: '-0.015em' }}
            >
              People Are Searching —<br />
              <span className="font-light italic text-[#7BAF8B]">Here Are the Answers</span>
            </h2>
          </div>
          <a
            href="https://smilebydrkortez.com/request-appointment"
            target="_blank"
            rel="noopener nofollow"
            className="bg-[#C4A96E] hover:bg-[#B8994F] text-[#1C3528] font-semibold text-sm px-7 py-3.5 rounded-full whitespace-nowrap cursor-pointer transition-colors duration-200 self-start md:self-end"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            Book an Appointment
          </a>
        </div>

        {/* Query cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {queries.map((q, idx) => (
            <div
              key={idx}
              className="bg-white/8 border border-white/10 rounded-2xl p-7 hover:bg-white/12 transition-colors duration-200"
            >
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-xl flex-shrink-0">
                  <i className={`${q.icon} text-[#C4A96E] text-base`} />
                </div>
                <div className="flex items-center gap-1.5">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#7BAF8B] animate-pulse" />
                  <span
                    className="text-[#7BAF8B] text-[10px] tracking-[0.2em] uppercase font-semibold"
                    style={{ fontFamily: 'DM Sans, sans-serif' }}
                  >
                    Voice Search
                  </span>
                </div>
              </div>

              <p
                className="text-white/85 italic leading-relaxed mb-5"
                style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '18px' }}
              >
                &ldquo;{q.query}&rdquo;
              </p>

              <div className="h-px bg-white/10 mb-4" />

              <div className="flex items-start gap-2.5">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-[#7BAF8B] text-sm" />
                </div>
                <p
                  className="text-white/55 text-xs leading-relaxed"
                  style={{ fontFamily: 'DM Sans, sans-serif' }}
                >
                  {q.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
